module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/sp/en_shikoku-9b5474570c0fd4087da1ff85eadf34fe.png";